import { memo } from "react";

import { StyledLeadScoreCountBadge } from "./styles";

interface ILeadScoreCountBadgeProps {
    count: number;
    isActive?: boolean;
    onClick: VoidFunction;
}

const LeadScoreCountBadge = ({ count, isActive, onClick }: ILeadScoreCountBadgeProps) => {
    return (
        <StyledLeadScoreCountBadge
            data-automation="lead-score-count-badge"
            type="button"
            $isClickable
            $isActive={isActive}
            onClick={onClick}
        >
            +{count}
        </StyledLeadScoreCountBadge>
    );
};

export default memo(LeadScoreCountBadge);
